import React from 'react'
import { Text } from 'shared/components'

import * as styles from './styles'

const EmptyFavoritesState = () => {
	return (
		<div css={styles.container}>
			<div css={styles.textContainer}>
				<Text size={18} bold white css={styles.title}>
					No beneficiaries here yet...
				</Text>
				<Text size={14} gray css={styles.subtitle}>
					You can choose your favorite<br />beneficiaries in the All tab.
				</Text>
			</div>

			<div css={styles.iconContainer}>
				<img
					src="./img/empty-favorites-bookmark.png"
					alt="No favorites"
					css={styles.bookmarkImage}
				/>
			</div>
		</div>
	)
}

export default EmptyFavoritesState 